import React from "react";
import { Stack, styled } from "@mui/material";
import TabVisual from "../visuals/TabVisual";

interface OptionInterface {
  id?: string;
  label: string;
  value: string;
}
const Container = styled(Stack)(({ theme }: any) => ({
  width: "100%",
  height: "80px",
  backgroundColor: theme.palette.common.white,
  boxShadow: `1px 1px 5px rgba(0, 0, 0, 0.1)`,
  overflow: "auto",
  overflowY: "hidden",
  margin: "0 auto",
  whiteSpace: "nowrap",
  "& button": {
    border: `1px solid ${theme.palette.common.borderGrey}`,
    color: "#000",
    backgroundColor: theme.palette.common.white,
  },
  "& button:hover,button:focus,button:active": {
    backgroundColor: theme.palette.common.green,
  },
}));

interface TabBarInterface {
  options: OptionInterface[];
  handleAction: (e: any) => void;
}

const TabBar = ({ options, handleAction }: TabBarInterface) => {
  return (
    <Container
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      padding={"20px 30px"}
    >
      {options.map((option: OptionInterface) => (
        <TabVisual
          className="button"
          onClick={() => handleAction(option.value)}
          label={option.label}
        />
      ))}
    </Container>
  );
};
export default TabBar;
